const prefix = "filter";

const CLEAR_FILTER = `${prefix}:CLEAR_FILTER`;
const LOAD_FILTER = `${prefix}:LOAD_FILTER`;
const CHANGE_FILTER_MATCH_CRITERIA = `${prefix}:CHANGE_FILTER_MATCH_CRITERIA`;
const CHANGE_LABEL_FILTER = `${prefix}:CHANGE_LABEL_FILTER`;
const CHANGE_SUMMARY_FILTER = `${prefix}:CHANGE_SUMMARY_FILTER`;
const CHANGE_TAGS_FILTER = `${prefix}:CHANGE_TAGS_FILTER`;
const CHANGE_TYPE_FILTER = `${prefix}:CHANGE_TYPE_FILTER`;
const CHANGE_COLOR_FILTER = `${prefix}:CHANGE_COLOR_FILTER`;
const CHANGE_SUPER_FILTER = `${prefix}:CHANGE_SUPER_FILTER`;
const CHANGE_DATE_FILTER = `${prefix}:CHANGE_DATE_FILTER`;
const CHANGE_DURATION_FILTER = `${prefix}:CHANGE_DURATION_FILTER`;
const CHANGE_NARRATIVE_FILTER = `${prefix}:CHANGE_NARRATIVE_FILTER`;
const CHANGE_TYPE_REFERENCE_FILTER = `${prefix}:CHANGE_TYPE_REFERENCE_FILTER`;
const CHANGE_REFERENCE_FILTER = `${prefix}:CHANGE_REFERENCE_FILTER`;
const CHANGE_TEXT_PROPERTY_FILTER = `${prefix}:CHANGE_TEXT_PROPERTY_FILTER`;
const CHANGE_NUMERIC_PROPERTY_FILTER = `${prefix}:CHANGE_NUMERIC_PROPERTY_FILTER`;
const CHANGE_BOOL_PROPERTY_FILTER = `${prefix}:CHANGE_BOOL_PROPERTY_FILTER`;
const REMOVE_REFERENCE_FILTER = `${prefix}:REMOVE_REFERENCE_FILTER`;
const REMOVE_TYPE_REFERENCE_FILTER = `${prefix}:REMOVE_TYPE_REFERENCE_FILTER`;
const REMOVE_TEXT_PROPERTIES_FILTER = `${prefix}:REMOVE_TEXT_PROPERTIES_FILTER`;
const REMOVE_NUMERIC_PROPERTIES_FILTER = `${prefix}:REMOVE_NUMERIC_PROPERTIES_FILTER`;
const REMOVE_BOOLEAN_PROPERTIES_FILTER = `${prefix}:REMOVE_BOOLEAN_PROPERTIES_FILTER`;

export const actionTypes = {
  CLEAR_FILTER,
  LOAD_FILTER,
  CHANGE_FILTER_MATCH_CRITERIA,
  CHANGE_LABEL_FILTER,
  CHANGE_SUMMARY_FILTER,
  CHANGE_TAGS_FILTER,
  CHANGE_TYPE_FILTER,
  CHANGE_COLOR_FILTER,
  CHANGE_SUPER_FILTER,
  CHANGE_DATE_FILTER,
  CHANGE_DURATION_FILTER,
  CHANGE_NARRATIVE_FILTER,
  CHANGE_TYPE_REFERENCE_FILTER,
  CHANGE_REFERENCE_FILTER,
  CHANGE_TEXT_PROPERTY_FILTER,
  CHANGE_NUMERIC_PROPERTY_FILTER,
  CHANGE_BOOL_PROPERTY_FILTER,
  REMOVE_REFERENCE_FILTER,
  REMOVE_TYPE_REFERENCE_FILTER,
  REMOVE_TEXT_PROPERTIES_FILTER,
  REMOVE_NUMERIC_PROPERTIES_FILTER,
  REMOVE_BOOLEAN_PROPERTIES_FILTER
};

const clearFilter = filterId => {
  return {
    type: CLEAR_FILTER,
    filterId
  };
};

const loadFilter = (targetFilterId, sourceFilterId) => {
  return {
    type: LOAD_FILTER,
    targetFilterId,
    sourceFilterId
  };
};

const changeFilterMatchCriteria = (filterId, match) => {
  return {
    type: CHANGE_FILTER_MATCH_CRITERIA,
    filterId,
    match
  };
};

const changeLabelFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_LABEL_FILTER,
    filterId,
    terms,
    match
  };
};

const changeSummaryFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_SUMMARY_FILTER,
    filterId,
    terms,
    match
  };
};

const changeTagsFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_TAGS_FILTER,
    filterId,
    terms,
    match
  };
};

const changeTypeFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_TYPE_FILTER,
    filterId,
    terms,
    match
  };
};

const changeColorFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_COLOR_FILTER,
    filterId,
    terms,
    match
  };
};

const changeSuperFilter = (filterId, terms, match) => {
  return {
    type: CHANGE_SUPER_FILTER,
    filterId,
    terms,
    match
  };
};

const changeDateFilter = (filterId, above, below) => {
  return {
    type: CHANGE_DATE_FILTER,
    filterId,
    above,
    below
  };
};

const changeDurationFilter = (filterId, above, below, isAboveIncluded = true, isBelowIncluded = true) => {
  return {
    type: CHANGE_DURATION_FILTER,
    filterId,
    above,
    below,
    isAboveIncluded,
    isBelowIncluded
  };
};

//Check if implemented
const changeNarrativeFilter = (filterId, narrativeStatus, from, to) => {
  return {
    type: CHANGE_NARRATIVE_FILTER,
    filterId,
    narrativeStatus,
    from,
    to
  };
};

//Person (indiscriminate of reference id)
const changeTypeReferenceFilter = (filterId, typeId, terms, match) => {
  return {
    type: CHANGE_TYPE_REFERENCE_FILTER,
    filterId,
    typeId,
    terms,
    match
  };
};

//witness or participant
const changeReferenceFilter = (filterId, referenceId, terms, match) => {
  return {
    type: CHANGE_REFERENCE_FILTER,
    filterId,
    referenceId,
    terms,
    match
  };
};

const changeTextPropertyFilter = (filterId, propertyId, terms, match) => {
  return {
    type: CHANGE_TEXT_PROPERTY_FILTER,
    filterId,
    propertyId,
    terms,
    match
  };
};

const changeNumericPropertyFilter = (filterId, propertyId, above, below) => {
  return {
    type: CHANGE_NUMERIC_PROPERTY_FILTER,
    filterId,
    propertyId,
    above,
    below
  };
};

const changeBoolPropertyFilter = (filterId, propertyId, expected) => {
  return {
    type: CHANGE_BOOL_PROPERTY_FILTER,
    filterId,
    propertyId,
    expected
  };
};

const removeReferenceFilter = (filterId, referenceId) => {
  return {
    type: REMOVE_REFERENCE_FILTER,
    filterId,
    referenceId
  };
};

const removeTypeReferenceFilter = (filterId, referenceId) => {
  return {
    type: REMOVE_TYPE_REFERENCE_FILTER,
    filterId,
    referenceId
  };
};

const removeTextPropertiesFilter = (filterId, referenceId) => {
  return {
    type: REMOVE_TEXT_PROPERTIES_FILTER,
    filterId,
    referenceId
  };
};

const removeNumericPropertiesFilter = (filterId, referenceId) => {
  return {
    type: REMOVE_NUMERIC_PROPERTIES_FILTER,
    filterId,
    referenceId
  };
};

const removeBooleanPropertiesFilter = (filterId, referenceId) => {
  return {
    type: REMOVE_BOOLEAN_PROPERTIES_FILTER,
    filterId,
    referenceId
  };
};

export default {
  clearFilter,
  loadFilter,
  changeFilterMatchCriteria,
  changeLabelFilter,
  changeSummaryFilter,
  changeTagsFilter,
  changeTypeFilter,
  changeColorFilter,
  changeSuperFilter,
  changeDateFilter,
  changeDurationFilter,
  changeNarrativeFilter,
  changeTypeReferenceFilter,
  changeReferenceFilter,
  changeTextPropertyFilter,
  changeNumericPropertyFilter,
  changeBoolPropertyFilter,
  removeReferenceFilter,
  removeTypeReferenceFilter,
  removeTextPropertiesFilter,
  removeNumericPropertiesFilter,
  removeBooleanPropertiesFilter
};
